export default __webpack_public_path__ + "static/media/regulatory--end-of-priority-road--g1.12c706be.png";